/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const CameraIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <rect fill="none" width="24" height="24" />
        <path d="m8.99,19.48h6.02l-.62-2.47h-4.79l-.62,2.47Zm.05-3.95h5.92c1.5,0,2.78-.53,3.84-1.59,1.06-1.06,1.59-2.34,1.59-3.84s-.53-2.78-1.59-3.84c-1.06-1.06-2.34-1.59-3.84-1.59h-5.92c-1.5,0-2.78.53-3.84,1.59-1.06,1.06-1.59,2.34-1.59,3.84s.53,2.78,1.59,3.84c1.06,1.06,2.34,1.59,3.84,1.59Zm2.96-2.96c-.69,0-1.27-.24-1.75-.72s-.72-1.06-.72-1.75.24-1.27.72-1.75c.48-.48,1.06-.72,1.75-.72s1.27.24,1.75.72c.48.48.72,1.06.72,1.75s-.24,1.27-.72,1.75-1.06.72-1.75.72Zm-5.5-3.77c.2,0,.37-.07.52-.22.15-.15.22-.32.22-.53s-.07-.38-.22-.52c-.15-.14-.32-.21-.53-.21s-.38.07-.52.21c-.14.14-.21.32-.21.53,0,.2.07.37.21.52.14.15.32.22.53.22Zm-2.39,12.16v-1.48h3.38l.64-2.52c-1.69-.23-3.12-.99-4.27-2.28-1.15-1.29-1.73-2.82-1.73-4.58,0-1.92.67-3.56,2.01-4.9,1.34-1.34,2.97-2.01,4.9-2.01h5.92c1.92,0,3.56.67,4.9,2.01,1.34,1.34,2.01,2.97,2.01,4.9,0,1.76-.58,3.29-1.73,4.58-1.15,1.29-2.57,2.05-4.27,2.28l.64,2.52h3.38v1.48H4.11Zm7.89-6.91c1.09,0,2.01-.39,2.79-1.16s1.16-1.7,1.16-2.79-.39-2.01-1.16-2.79c-.77-.77-1.7-1.16-2.79-1.16s-2.01.39-2.79,1.16c-.77.77-1.16,1.7-1.16,2.79s.39,2.01,1.16,2.79c.77.77,1.7,1.16,2.79,1.16Z" />
      </svg>
    </SvgIcon>
  );
};

export default CameraIcon;
